module.exports = __webpack_public_path__ + "static/img/134.cae020c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/134.png
// module id = h55Q
// module chunks = 0